import { useQueryClient } from "@tanstack/react-query";
import type { ParentData } from "features/cases/blocks/CommonCard/CommonCard.types";
import { getQid } from "features/cases/blocks/CommonCard/CommonCard.utils";
import { EDITORIAL_UNREVIEWED_QUERY_KEY } from "features/editorial/types";
import { MODERATORIAL_CASES_QUERY_KEY } from "features/moderatorial/types";

export const useOnStatusChange = (
  parentData: ParentData,
  queryId: string | undefined,
) => {
  const queryClient = useQueryClient();

  const qid = getQid(parentData, queryId);

  return () => {
    queryClient.invalidateQueries({
      queryKey: [qid],
      refetchType: "none",
    });

    if (parentData.fromCatalog) {
      queryClient.invalidateQueries({
        queryKey: ["cases"],
        refetchType: "none",
      });
    }

    if (parentData.fromModeratorialFeed) {
      queryClient.invalidateQueries({
        queryKey: [MODERATORIAL_CASES_QUERY_KEY],
      });
    }

    if (parentData.fromEditorialFeed) {
      queryClient.invalidateQueries({
        queryKey: [EDITORIAL_UNREVIEWED_QUERY_KEY],
      });
    }
  };
};
